<template>
    <AuthLayout v-bind="appSharedData.getAuthLayoutProps()">
        <template #title> Verify your email address </template>

        <template #card-content>
            <Alert
                type="info"
                title="Almost there!"
                class="mb-4"
            >
                <span
                    v-if="gmailSniperLink"
                    class="flex flex-col space-y-2"
                >
                    <span> Now you only need to verify your email. </span>
                    <span>
                        <a
                            :href="gmailSniperLink"
                            target="_blank"
                            class="font-bold hover:underline"
                        >
                            Click here
                        </a>
                        to access the email we sent to your Gmail account.
                    </span>
                </span>
                <span v-else>
                    Now you only need to verify your email by clicking on the
                    link we sent you.
                </span>
            </Alert>

            <div>
                <ApiForm
                    :url="RoutePathAppEnum.Auth_EmailVerification_Resend"
                    method="POST"
                    ref="resendVerificationEmailApiFormRef"
                />
                <Button
                    @click="resendVerificationEmailApiFormRef?.submit()"
                    :loading="
                        resendVerificationEmailApiFormRef?.loading.valueOf()
                    "
                    class="w-full mt-2"
                >
                    Resend verification email
                </Button>
            </div>

            <div class="mt-2">
                <ApiForm
                    :url="RoutePathAppEnum.Auth_Logout"
                    method="POST"
                    ref="logoutApiFormRef"
                />
                <span
                    @click="logoutApiFormRef?.submit()"
                    class="hover:underline cursor-pointer text-sm text-gray-600"
                >
                    Logout
                </span>
            </div>
        </template>
    </AuthLayout>
</template>

<script setup lang="ts">
    import { ref } from 'vue'
    import AuthLayout from '@/Shared/Layout/App/Auth/AuthLayout.vue'
    import Button from '@/Shared/Component/Button.vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import Alert from '@/Shared/Component/Alert.vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import AppSharedData from '@/Shared/Entity/AppSharedData'
    import { RoutePathAppEnum } from '@/Shared/AutoGenerated/RoutePathEnum'

    interface ShowEmailVerificationProps {
        appSharedDataData: any
        gmailSniperLink: string
    }

    const props = defineProps<ShowEmailVerificationProps>()
    const appSharedData = AppSharedData.hydrate(props.appSharedDataData)
    const logoutApiFormRef = ref<ApiFormRefType>(null)
    const resendVerificationEmailApiFormRef = ref<ApiFormRefType>(null)
</script>
